module.exports = __webpack_public_path__ + "img/lantern.77706ee4.png";